import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { AssignerGroupDossier } from "src/app/core/services/business/model/assigner-group-dossier";
import { UserProfileService } from "src/app/parametrage/core/service/user-profile.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";

@Component({
  selector: "app-form-assigner-group-dossier",
  templateUrl: "./form-assigner-group-dossier.component.html",
  styleUrls: ["./form-assigner-group-dossier.component.scss"],
})
export class FormAssignerGroupDossierComponent implements OnInit {
  dateEcheance: any;
  time: any;

  @Input() dossierList;

  employees: Employee[];
  userprofiles: UserProfile[];

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  assignerGroupDossier: AssignerGroupDossier = new AssignerGroupDossier();

  constructor(
    private _router: Router,
    private _userProfileService: UserProfileService,
    private _employeeService: EmployeeService,
    private _requestService: RequestService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      RoleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
      dueDate: ["", [Validators.compose([Validators.required])]],
      dueHour: ["", [Validators.compose([Validators.required])]],
    });
  }

  ngOnInit() {
    this.getUserProfil();
  }

  getUserProfil() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userprofiles = data.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleId = this.form2.controls["RoleAffected"].value;
    this._employeeService.getEmployeeByProfile(roleId).subscribe(
      (data) => {
        this.employees = data.sort((a, b) => (a.id > b.id ? 1 : -1));
        this.form2.controls["userAffected"].setValue(
          data[data.length - 1].username
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  assignTask(): void {
    let month;
    month = this.dateEcheance.month;
    if (this.dateEcheance.month < 10) {
      month = "0" + this.dateEcheance.month;
    }

    let day;
    day = this.dateEcheance.day;
    if (this.dateEcheance.day < 10) {
      day = "0" + this.dateEcheance.day;
    }

    let hour;
    hour = this.time.hour;
    if (this.time.hour < 10) {
      hour = "0" + this.time.hour;
    }

    let minute;
    minute = this.time.minute;
    if (this.time.minute < 10) {
      minute = "0" + this.time.minute;
    }

    this.spinner.show();
    this.assignerGroupDossier.username = this.form2.value.userAffected;
    this.assignerGroupDossier.dueDate =
      this.dateEcheance.year +
      "-" +
      month +
      "-" +
      day +
      "T" +
      hour +
      ":" +
      minute;
    this.assignerGroupDossier.taskIdList = this.dossierList;

    this._requestService
      .assignerGroupDossier(this.assignerGroupDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
